// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 179) return "main.css";
	// return url for filenames based on template
	return "" + ({"206":"QRCode","231":"checkout","362":"Dashboard","621":"AddProduct","788":"ShareProduct"}[chunkId] || chunkId) + ".css";
};